var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"wave-header swiper-container swiper-init demo-slider-container"},[_c('swiper-slide',{staticClass:"demo-slider",staticStyle:{"background-image":"url(http://src.thu.edu.tw/upload/news_upload/1553066367.jpg)"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5aae032","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/header-image.vue
// module id = null
// module chunks = 